import { PUSH_ENDPOINT_TYPE } from "../interfaces/PUSH_ENDPOINT_TYPE";
export class PushEndPoint {
    constructor(public readonly pushEndPointType: PUSH_ENDPOINT_TYPE, public readonly pushEndPointToken: string, public readonly devDesc: string, public readonly uuid: string) {
    }
}